import React, { useEffect } from 'react';

// Chakra imports
import { Box, useColorModeValue } from '@chakra-ui/react';
import JournalVoucher from './Pages/JournalVoucher';
import { useUser } from 'contexts';

export default function Marketplace() {
   const { user } = useUser();

   useEffect(() => {
      if (user && !user?.packageData?.[0]?.jv) {
         window.history.back();
      }
   }, [user]);
   // Chakra Color Mode
   const textColor = useColorModeValue('secondaryZeronine.900', 'white');
   const textColorBrand = useColorModeValue('secondaryZeronine.500', 'white');
   return (
      <Box pt="10px" width="100%" height="100%">
         <JournalVoucher />
      </Box>
   );
}
